import * as types from "./../constants/ActionTypes";
export const actFetchListPayPalAccounts = (listPayPalAccounts) => {
	return {
		type: types.FETCH_LIST_PAYPAL_ACCOUNTS,
		listPayPalAccounts: listPayPalAccounts,
	};
};

export const actFetchShowLoadingPage = (showLoadingPage) => {
	return {
		type: types.FETCH_SHOW_LOADING_PAGE,
		showLoadingPage: showLoadingPage,
	};
};

export const actFetchDataSettings = (dataSettings) => {
	return {
		type: types.FETCH_DATA_SETTINGS,
		dataSettings: dataSettings,
	};
};

export const actFetchDataStatistical = (dataStatistical) => {
	return {
		type: types.FETCH_DATA_STATISTICAL,
		dataStatistical: dataStatistical,
	};
};

export const actFetchListStore = (listStore) => {
	return {
		type: types.FETCH_DATA_LIST_STORE,
		listStore,
	};
};

export const actFetchFilter = (filter) => {
	/** filter is object with two key: payment and status */
	return {
		type: types.FETCH_FILTER,
		filter: filter,
	};
};

export const actFecthPlanTable = (status) => {
	return {
		type: types.FECTH_PLAN_TABLE,
		status: status,
	};
};

export const actFecthModalYearlyPlan = (modal) => {
	return {
		type: types.FECTH_MODAL_YEARLY_PLAN,
		payload: modal,
	};
};

export const actFecthModalYearlyPlanEnhance = (modal) => {
	return {
		type: types.FECTH_MODAL_YEARLY_PLAN_ENHANCE,
		payload: modal,
	};
};

export const actFecthModalCharge = (isOpen) => {
	return {
		type: types.FETCH_MODAL_CHARGE,
		payload: isOpen,
	};
};

export const actFecthYearEndWrap = payload => {
	return {
		type: types.FETCH_YEAR_END_WRAP,
		payload
	}
}

export const setYearEndData = payload => {
	return {
		type: types.SET_YEAR_END_DATA,
		payload
	}
}

export const setHasYearEnd = payload => {
	return {
		type: types.FETCH_HAS_YEAR_END,
		payload,
	}
}
